var $$ = $$ || {};

$$.FeedbackSlider = class FeedbackSlider {
	constructor (root, options) {
		this.root = root;
		this.currentSlide = 0;
		this.isAnimating = false;

		this.options = {
			duration: 300,
			easing: 'swing'
		};

		this.slidesCount = 0;
		this.slideWidth = $$.windowWidth;

		_.assign(this.options, options);
		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_cacheNodes () {
		this.nodes = {
			itemsWrapper: this.root.find('.js-items'),
			backward: this.root.find('.js-backward'),
			forward: this.root.find('.js-forward'),
			bullsWrapper: this.root.find('.js-pages'),
			currentSlide: this.root.find('.js-current-slide'),
			items: this.root.find('.js-item'),
			description: this.root.find('.js-description')
		};
	}

	_bindEvents () {
		this.nodes.backward.on('click', () => {
			this._previousSlide();
		});

		this.nodes.forward.on('click', () => {
			this._nextSlide();
		});

		$$.window.on('resize', () => {
			this._resize();
			this._goToStart();
		});

		this.nodes.bullsWrapper.on('click', '.js-page', (event) => {
			var currentBull = $(event.currentTarget);
			this._goToSlide(currentBull.index());
		});
	}

	_ready () {
		this.showCount = ($$.windowWidth / 480) | 0;

		this.nodes.items.filter(':nth-of-type(' + this.showCount + 'n)').css({
			marginRight: $$.windowWidth - this.showCount * 480
		});

		this.slidesCount = Math.ceil(this.nodes.items.length / this.showCount);

		this.nodes.bullsWrapper.empty();

		for (var i = 1; i <= this.slidesCount; i++) {
			this.nodes.bullsWrapper.append('<div class="page js-page"/>');
		}
	}

	_resize () {
		$$.windowWidth = $$.window.width();
		this.nodes.items.css({ marginRight: 0 });

		this.showCount = ($$.windowWidth / 480) | 0;

		this.nodes.items.filter(':nth-of-type(' + this.showCount + 'n)').css({
			marginRight: $$.windowWidth - this.showCount * 480
		});

		this.slidesCount = Math.ceil(this.nodes.items.length / this.showCount);

		this.slideWidth = $$.windowWidth;

		this.nodes.bullsWrapper.empty();

		for (var i = 1; i <= this.slidesCount; i++) {
			this.nodes.bullsWrapper.append('<div class="page js-page"/>');
		}
	}

	_nextSlide () {
		this.nodes.description.eq(this.currentSlide).removeClass('show');
		this.currentSlide = this.currentSlide + 1;
		this._goToSlide(this.currentSlide);
	}

	_previousSlide () {
		this.nodes.description.eq(this.currentSlide).removeClass('show');
		this.currentSlide = this.currentSlide - 1;
		this._goToSlide(this.currentSlide);
	}

	_goToSlide (slideNumber) {
		if (this.isAnimating) {
			return;
		}

		if (slideNumber < 0) {
			this.currentSlide = this.slidesCount - 1;
			this._goToEnd();
			return;
		} else if (slideNumber >= this.slidesCount) {
			this.currentSlide = 0;
			this._goToStart();
			return;
		}

		this.isAnimating = true;

		this.nodes.itemsWrapper.animate({
			marginLeft: -this.slideWidth * slideNumber
		}, this.options.duration, this.options.easing, () => {
			this.isAnimating = false;
		});

		this.currentSlide = slideNumber;
		this.nodes.bullsWrapper.find('.js-page').removeClass('active').eq(this.currentSlide).addClass('active');
	}

	_goToEnd () {
		var slideItem = this.nodes.items.last().clone();

		this.nodes.itemsWrapper.prepend(slideItem);
		this.nodes.itemsWrapper.css({ marginLeft: -this.slideWidth });

		this.nodes.itemsWrapper.animate({
			marginLeft: 0
		}, this.options.duration, this.options.easing, () => {
			var marginLeft = -this.currentSlide * this.slideWidth;

			this.isAnimating = false;
			this.nodes.itemsWrapper.css({ marginLeft: marginLeft });
			slideItem.remove();
		});

		this.currentSlide = this.slidesCount;
		this.nodes.bullsWrapper.find('.js-page').removeClass('active').eq(this.currentSlide).addClass('active');
	}

	_goToStart () {
		var slideItem = this.nodes.items.first().clone();

		this.nodes.itemsWrapper.append(slideItem);

		this.nodes.itemsWrapper.animate({
			marginLeft: -this.nodes.items.length * this.slideWidth
		}, this.options.duration, 'swing', () => {
			slideItem.remove();
			this.nodes.itemsWrapper.css({ marginLeft: 0 });
			this.isAnimating = false;
		});

		this.currentSlide = 0;
		this.nodes.bullsWrapper.find('.js-page').removeClass('active').eq(this.currentSlide).addClass('active');
	}
};
